<script lang="ts">
    import Calendar from "../../components/formComponents/Calendar.svelte"
    import Select from "../inputfields/Select.svelte"
    import Input from "../../components/formComponents/Input.svelte"
    import Cta from "../../components/CTA.svelte"
    import { onChange } from "../../components/formComponents/helper"

    export let task: TaskOilSpillRemoval | TaskTowing
    export let editMode = false
    export let refresh = false
    export let onDeleteEntry: (index: number) => void
    export let onEntryChanged: (index: number) => void = () => {}
    export let onAdditionalInfoBlur: (valueChanged: boolean) => void = () => {}
</script>

<div class="main-wrapper">
    <ul class="wrapper form">
        {#key [editMode, refresh]}
            {#each [...(task.manualProtocol?.entries || [])] as entry, i}
                <li class:editMode="{editMode}">
                    <div>
                        <Calendar
                            placeholder="Zeitstempel"
                            id="timestamp-{i}"
                            bind:dateValue="{entry.datetime}"
                            editMode="{editMode || i == 0}"
                            timestamp="{true}"
                            greyMode="{i == 0}"
                            on:change="{() => onEntryChanged(i)}"
                        />
                    </div>
                    <div>
                        <Select
                            editMode="{editMode || i == 0}"
                            field="{{
                                widget: 'select',
                                label: 'Aktion',
                                name: 'eventId',
                                options: {
                                    endpoint: 'option',
                                    params: {
                                        sort: 'name',
                                        filter: {
                                            category: 'taskEvent',
                                            'additionalInfos.taskTypes':
                                                task.taskType == 'oilSpillRemoval' ? 'oilTrack' : 'towing',
                                        },
                                    },
                                    mapping: {
                                        id: 'id',
                                        name: 'name',
                                    },
                                },
                            }}"
                            placeholder="Aktion auswählen"
                            bind:value="{entry.eventId}"
                            on:valueChanged="{() => onEntryChanged(i)}"
                        />
                    </div>
                    {#if editMode}
                        <div class="trash">
                            <Cta
                                type="tableButton"
                                icon="solar_trash-bin-trash-outline"
                                on:click="{() => onDeleteEntry(i)}"
                            />
                        </div>
                    {/if}
                </li>
            {/each}
        {/key}
    </ul>
    <div class="form">
        <Input
            type="textarea"
            placeholder="Zusatzinformationen"
            bind:value="{task.manualProtocol.additionalInformation}"
            onChange="{onChange}"
            id="additionalInformation"
            onBlur="{(_, valueChanged) => valueChanged && onAdditionalInfoBlur(valueChanged)}"
        />
    </div>
</div>

<style lang="less">
    @import "../../../../assets/variables.less";
    .main-wrapper {
        min-height: 300px;
        .wrapper {
            display: flex;
            gap: 0.6rem;
            flex-direction: column;

            padding: 1.2rem 0px;
            li {
                display: grid;
                align-items: center;
                justify-items: center;
                gap: 0.6rem;
                padding: 0.6rem;
                border: 1px solid var(--grey-300);
                border-radius: 12px;
                grid-template-columns: 1fr 1fr;
                @media @mobile {
                    display: flex;
                    flex-direction: column;
                }
                div {
                    width: 100%;
                    height: 100%;
                }
                &.editMode {
                    grid-template-columns: 6fr 5fr 1fr;
                    .trash {
                        width: 1.6rem;
                        height: 1.6rem;
                    }
                    @media @mobile {
                        display: grid;
                        grid-template-columns: 5fr 1fr !important;
                        > :nth-child(1) {
                            grid-column: 1 / 2 !important;
                            grid-row: 1 / 2 !important;
                        }

                        > :nth-child(2) {
                            grid-column: 1 / 2 !important;
                            grid-row: 2 / 3 !important;
                        }

                        > :nth-child(3) {
                            grid-column: 2 / 3 !important;
                            grid-row: 1 / 3 !important;
                            display: flex;
                            height: 100%;
                            align-items: center;
                        }
                    }
                }
            }
        }
    }
</style>
